//import { takeLatest, call, put } from 'redux-saga/effects';

//import { getAPIDataLoaded, getAPIDataError } from './actions';

function* apiData() {
  
}

export default apiData;



// WEBPACK FOOTER //
// ./src/containers/App/sagas.js